import requestModule from "@/application/libs/requestModule";
import Util from "@/application/libs/util";
import EventModule from "@/application/libs/eventModule";
import moment from "moment";
import { t } from 'i18next';

export default {
    confirmRecalcCosts(component) {
        const pratos = (component.cardData &&
            component.cardData.dataCatalog &&
            component.cardData.dataCatalog.pratos) || {};
        const dataCatalog = (component.cardData && component.cardData.dataCatalog) || {};
        const dtRefeCusto = moment(component.formData.DTREFECUSTO).format('DD/MM/YYYY');
        return requestModule.postRequest('caloptServer', {
            FROM: "updateCost",
            cloneData: {
                NRCENARIOCARD: (component.nrcenario && component.nrcenario.NRCENARIOCARD) || null,
                NRTIPOCUSTO: component.formData.costType.CDTIPOCUSTO,
                DTREFECUSTO: dtRefeCusto,
                NRORG: Util.getLocalVar("userData").NRORG,
                PRATOS: Object.keys(pratos),
                dataCatalog: dataCatalog,
                CDFILIAL: Util.getFilterInSession().CDFILIAL,
                CDSERVFILI: Util.getFilterInSession().CDSERVFILI
            }
        }).then(response => {
            response = response && response.dataset && response.dataset.cardIntStatus;
            if (typeof (response && response[0]) == 'string') {
                response = JSON.parse(response[0]);
            }

            Util.showSuccessNotification({
                title: t('atualiza_custos'),
                text: t('atualiza_custos_confirmado')
            });
            EventModule.$emit('costsRecalculated', {
                dataCatalog: response.data.dataCatalog,
                custoUpdateReport: response.data.dataCatalog?.custoUpdateReport ?? {},
                costType: component.formData.costType,
                DTREFECUSTO: dtRefeCusto
            });
            component.$emit('close');
        }).catch(error => {
            Util.showErrorNotification({
                title: t('error_saving'),
                text: t('atualiza_custos_erro')
            });
            console.log(error);
        });
    }
}
